import React from 'react';
import './TierCard.css';

function TierCard({ title, price, features, onSelect, disabled, isPopular }) {
  return (
    <div className={`tier-card ${isPopular ? 'popular' : ''}`}>
      {isPopular && <div className="popular-badge">RECOMMENDED</div>}
      
      <div className="tier-header">
        <h3 className="tier-title">{title}</h3>
        <div className="tier-price">
          <span className="price">{price}</span>
        </div>
      </div>

      <ul className="tier-features">
        {features.map((feature, index) => (
          <li key={index} className="feature-item">
            <i className="bi-check-circle-fill checkmark"></i>
            {feature}
          </li>
        ))}
      </ul>

      <button 
        className="tier-button"
        onClick={onSelect}
        disabled={disabled}
      >
        Select {title}
      </button>
    </div>
  );
}

export default TierCard;

